import { PayloadAction } from '../../../store.model';
import { LOAD_MORE_LENGTH } from '../fixture/load-more-length';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../search.action';
import { SearchState } from '../search.state';

import { LoadMore } from './load-more.action';

export function loadMoreReducer(
    state: SearchState,
    _: PayloadAction<ActionType.EVAL_SEARCH__LOAD_MORE, LoadMore>,
): SearchState {
    const nextFilteredRowsLength = state.filteredRowsLength + LOAD_MORE_LENGTH;
    let nextFilteredRows = sortRows(state.rows, state.sortOptions);
    nextFilteredRows = nextFilteredRows.slice(0, nextFilteredRowsLength);

    const nextCanLoadMore = state.rows > nextFilteredRows;

    return {
        ...state,
        filteredRows: nextFilteredRows,
        filteredRowsLength: nextFilteredRowsLength,
        canLoadMore: nextCanLoadMore,
    };
}
